import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HNG_APP_CONFIG, HngAppConfig } from '@hidat/ng-common';
import {
  EventTrackerConfig,
  EventTrackerModule,
  loadStationInitializer
} from '@splixer/player';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';

const appConfig = new HngAppConfig({
  appCode: 'knhc-player',
  appName: 'KNHC On Demand',
  apiUrl: environment.splixerUrl,
  userApiUrl: ''
});

const eventTrackerConfig: EventTrackerConfig = {
  primaryTrackingCode: environment.defaultGaTrackingId
};

export const knhcConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HNG_APP_CONFIG, useValue: appConfig },
    importProvidersFrom(NgxGoogleAnalyticsModule.forRoot(environment.defaultGaTrackingId)),
    importProvidersFrom(NgxGoogleAnalyticsRouterModule),
    importProvidersFrom(EventTrackerModule.forRoot(eventTrackerConfig)),
    provideAppInitializer(() => {
      return loadStationInitializer(environment.defaultStationCode, 'KNHC', {
        featured: true,
        recents: true,
        genres: false,
        mixCategories: false,
        dmcaSkipSeconds: 596,
      });
    })
  ]
};
